import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { idZodSchema } from "@@/shared/id";
import { generateId } from "@@/utilities/generate-id";
import type { Except } from "type-fest";
import type { ZodSchema} from "zod";
import { z } from "zod";
import { providerIdZodSchema } from "../../provider-id";
import { companyDetailsIdZodSchema } from "../company-details-id";
import { orgNrZodSchema } from "../company-swedish";

const companyDetailsEditCommandZodObject = z
    .object({
        _id: idZodSchema,
        _createdAt: isoAndUnixZodSchema,
        _type: z.literal("COMPANY_DETAILS_EDIT_COMMAND"),
        legalName: z.string(),
        name: z.string().optional(),
        orgNr: orgNrZodSchema,
        detailId: companyDetailsIdZodSchema,
        linkProvider: providerIdZodSchema.optional(),
        address: z.object({
            street: z.string(),
            city: z.string(),
            zipCode: z.string(),
            country: z.string(),
        }),
    })
    .and(
        z
            .object({
                vatNo: z.string().optional(),
                isNotVatRegistered: z.literal(true),
            })
            .or(
                z.object({
                    vatNo: z.string().min(1),
                    isNotVatRegistered: z.literal(false).optional(),
                }),
            ),
    );
type CompanyDetailsEditCommand = z.infer<
    typeof companyDetailsEditCommandZodObject
>;
const companyDetailsEditCommandZodSchema: ZodSchema<CompanyDetailsEditCommand> =
    companyDetailsEditCommandZodObject;

type CompanyDetailsEditCommandFactoryParams = Except<
    CompanyDetailsEditCommand,
    "_id" | "_type" | "_createdAt"
>;

function companyDetailsEditCommandFactory(
    params: CompanyDetailsEditCommandFactoryParams,
): CompanyDetailsEditCommand {
    return {
        ...params,
        _id: generateId("COMPANY_DETAILS_EDIT__"),
        _type: "COMPANY_DETAILS_EDIT_COMMAND",
        _createdAt: nowIsoAndUnix(),
    };
}

export { companyDetailsEditCommandFactory, companyDetailsEditCommandZodSchema };
export type {
    CompanyDetailsEditCommand,
    CompanyDetailsEditCommandFactoryParams,
};
